import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "The patented eGeeTouch Smartlock deploys proprietary advanced NFC-driven proximity access-gaining technology as the PRIMARY access method which is superior for (1) higher security, (2) faster connection speed, & (3) negligible power consumption in comparison to other Bluetooth-driven locks.",
    reply2:
      "Particularly, (i) NFC is secured close-proximity access eradicating concerns over any unwanted vicinity interception or hijacking Over-The-Air (OTA) transmissions. (ii) NFC connection is instantaneous (less than 1 second) while Bluetooth connection requires initialization time that typically takes several seconds which could be rather annoying when experienced daily. (iii) NFC-paired devices such as smartphone requires negligible power as compared to Bluetooth. And, NFC Tags are passive devices which do not need their own power source to operate.",
    reply3:
      "However, Bluetooth is also provided here as SECONDARY access choice and VICINITY TRACKING® to both Android & iOS smartphones owners to accomodate users who prioritise convenience over high security in view of individual preference and personal circumstances.",
    back: "Back",
  },
  ja: {
    reply1:
      "特許取得済みの eGeeTouch Smartlock は、独自の高度な NFC 駆動の近接アクセス取得テクノロジーをプライマリ アクセス方法として導入しており、他の Bluetooth と比較して、(1) 高いセキュリティ、(2) より速い接続速度、および (3) 無視できる消費電力の点で優れています駆動ロック。",
    reply2:
      "特に、(i) NFC は安全な近接アクセスであり、近隣での不要な傍受や無線 (OTA) 送信のハイジャックに対する懸念を解消します。 (ii) NFC 接続は瞬時 (1 秒未満) ですが、Bluetooth 接続には初期化時間が必要で、通常は数秒かかりますが、これは毎日経験するとかなり面倒になる可能性があります。 (iii) スマートフォンなどの NFC ペアリングされたデバイスは、Bluetooth と比較してごくわずかな電力を必要とします。また、NFC タグは受動的なデバイスであり、動作するために独自の電源を必要としません。",
    reply3:
      "ただし、ここでは、個人の好みや個人的な状況を考慮して、高いセキュリティよりも利便性を優先するユーザーに対応するために、Android および iOS スマートフォンの両方の所有者に、二次アクセスの選択肢および VICINITY TRACKING® として Bluetooth も提供されます。",
    back: "戻る",
  },
  es: {
    reply1:
      "El patentado eGeeTouch Smartlock implementa tecnología patentada avanzada de acceso por proximidad impulsada por NFC como método de acceso PRIMARIO que es superior para (1) mayor seguridad, (2) velocidad de conexión más rápida y (3) consumo de energía insignificante en comparación con otros dispositivos Bluetooth candados accionadas.",
    reply2:
      "En particular, (i) NFC es un acceso seguro de proximidad que elimina las preocupaciones sobre cualquier interceptación no deseada o secuestro de transmisiones por aire (OTA). (ii) La conexión NFC es instantánea (menos de 1 segundo), mientras que la conexión Bluetooth requiere un tiempo de inicialización que normalmente demora varios segundos, lo que puede resultar bastante molesto si se experimenta a diario. (iii) Los dispositivos emparejados con NFC, como los teléfonos inteligentes, requieren una energía insignificante en comparación con Bluetooth. Y las etiquetas NFC son dispositivos pasivos que no necesitan su propia fuente de energía para funcionar.",
    reply3:
      "Sin embargo, Bluetooth también se proporciona aquí como opción de acceso SECUNDARIO y VICINITY TRACKING® para propietarios de teléfonos inteligentes Android e iOS para adaptarse a los usuarios que priorizan la comodidad sobre la alta seguridad en vista de las preferencias individuales y las circunstancias personales.",
    back: "Atrás",
  },
});

class Q2_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <br />
        <br />
        {localizationStrings.reply3}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q2_component;
